import { Injectable } from '@angular/core';

import { FitApiClientService, FitList } from '@shared/fit-api-client.service';
import { unwrapAdminListItems } from '@shared/admin-list-response.util';

interface InstructorSearch {
    id: number;
    name: string;
    order: number;
}

interface InstructorImage {
    id: number;
    name: string;
    type: string;
    source: string;
    mime_type: string;
    extension: string;
    url: string;
    thumbnail_url: string;
    size: string;
    width_in_pixels: number;
    height_in_pixels: number;
    status: string;
    is_display_only: boolean;
}

interface InstructorResponse extends InstructorSearch {
    image?: InstructorImage;
    bio?: string;
    note: string;
}

interface InstructorRequest {
    name: string;
    order: number;
    note: string;
}

export { FitList, InstructorSearch, InstructorResponse };

@Injectable({ providedIn: 'root' })
export class InstructorService {
    constructor(private fitApi: FitApiClientService) { }

    public search(query: string, page: number) {
        return this.fitApi.get<FitList<InstructorSearch>>('/admin/instructor', {
            search: query,
            page: page.toString()
        });
    }

    public all() {
        return this.fitApi.get<Record<string, unknown>>('/admin/instructor/list').then(({ data, error }) => ({
            data: unwrapAdminListItems<InstructorSearch>(data, ['instructors']),
            error,
        }));
    }

    public get(id: number) {
        return this.fitApi.get<InstructorResponse>('/admin/instructor/' + id);
    }

    public create(instructor: InstructorResponse) {
        return this.fitApi.put<InstructorResponse>('/admin/instructor/0', this.mapToRequest(instructor));
    }

    public update(instructor: InstructorResponse) {
        return this.fitApi.put<InstructorResponse>('/admin/instructor/' + instructor.id, this.mapToRequest(instructor));
    }

    public delete(id: number) {
        return this.fitApi.delete<any>('/admin/instructor/' + id);
    }

    private mapToRequest(instructor: InstructorResponse): InstructorRequest {
        return {
            name: instructor.name,
            order: instructor.order,
            note: instructor.note
        };
    }
}
